import { Component } from '@angular/core';
import { LnImageFrameComponent } from '@components/ln-image-frame/ln-image-frame.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'ln-blog-hero',
  imports: [LnImageFrameComponent, TranslocoPipe],
  templateUrl: './blog-hero.component.html',
  styleUrl: './blog-hero.component.css',
})
export class BlogHeroComponent {
  protected readonly imageUrl = environment.GOOGLE_STORAGE_URL + '/imagenes/' + environment.banners.BLOG;
}
